import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "../screens/User/Home/Home.css";
import Typed from "react-typed";
import PropTypes from "prop-types";
// import "bootstrap/dist/css/bootstrap.css";
import Logo from "../images/Slonne.png";
const FirstSection = () => {
  return (
    <section
      id="hero"
      class="d-flex align-items-center justify-content-around"
      // style={{
      //     position: "relative",
      //   display: "flex",
      //   justifyContent: "space-between",
      //   alignItems: "center",
      // }}
      // class="container"
    >
      <div class="headingStyle" alt="Logo" />
      {/* <div style={{ position: "absolute" }}> */}
      <div
        class="container d-flex justify-content-between"
        style={{ position: "absolute" }}
      >
        <div class="row">
          <div
            class="col-lg-6 pt-5 pt-lg-0 order-2 order-lg-1 d-flex flex-column justify-content-center"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            {" "}
            <div
              id="simpleUsage"
              // style={{ fontSize: "2rem " }}
            >
              <h1
                style={{
                  // backgroundColor: 'black',
                  color: "white",
                  // WebkitTextFillColor: "transparent",
                  WebkitTextStroke: "1px #7666df",
                }}
              >
                Build Awesome apps with{" "}
                <Typed
                  style={{
                    // backgroundColor: 'black',
                    color: "white",
                    WebkitTextFillColor: "transparent",
                    WebkitTextStroke: "1px white",
                  }}
                  strings={[
                    "React",
                    "Node.js",
                    "React Native",
                    "PWA",
                    // "React Native Expo",
                    "Expo",
                    "Firebase",
                    "Material UI",
                    "React Native Paper",
                    "Bootstrap",
                  ]}
                  typeSpeed={70}
                  backSpeed={60}
                  loop
                />
              </h1>
            </div>
            <p
              style={{
                // backgroundColor: 'black',
                color: "black",
                // WebkitTextFillColor: "transparent",
                // WebkitTextStroke: "0.5px white",
                // border: "none",
                // fontWeight: 100,
                // WebkitTextStroke: "1px #7666df96",
                fontSize: "1.2rem",
              }}
            >
              We are team of talented designers and developers for making
              websites, Web Application & Mobile Apps
            </p>
            <div class="d-flex justify-content-center justify-content-lg-start">
              <div
                style={{
                  // display: "flex",
                  // justifyContent: "center",
                  alignItems: "center",
                }}
                // className="mt-2"
              >
                <a
                  className="asd"
                  style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
                  href="https://api.whatsapp.com/send?phone=923453048496&text=&source=&data="
                  target="blank"
                  data-tip="Whatsapp"
                  data-place="left"
                >
                  {/* <Icon size={32} icon={whatsapp} /> */}
                  <i class="fab fa-whatsapp-square fa-2x"></i>
                </a>
                <a
                  className="asd"
                  style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
                  href="https://github.com/fidato818"
                  target="blank"
                  data-tip="Github"
                >
                  {/* <Icon size={32} icon={github} /> */}
                  <i class="fab fa-github-square fa-2x"></i>
                </a>
                <a
                  className="asd"
                  style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
                  href="https://www.facebook.com/millions818"
                  target="blank"
                  data-tip="Facebook"
                >
                  {/* <Icon size={32} icon={facebookOfficial} /> */}
                  <i class="fab fa-facebook-square fa-2x"></i>
                </a>
                <a
                  className="asd"
                  style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
                  href="https://www.linkedin.com/in/adnan-ahmed-28160298/"
                  target="blank"
                  data-tip="linkedn"
                >
                  <i class="fab fa-linkedin fa-2x"></i>
                  {/* <Icon size={32} icon={linkedinSquare} /> */}
                </a>
                <a
                  className="asd"
                  style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
                  href="https://twitter.com/AdnanAhmed_818"
                  target="blank"
                  data-tip="twitter"
                >
                  {/* <Icon size={32} icon={twitter} /> */}
                  <i class="fab fa-twitter-square fa-2x"></i>
                </a>
                <a
                  className="asd"
                  style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
                  href="https://www.instagram.com/adnan_ahmed818/"
                  target="blank"
                  data-tip="Instagram"
                >
                  <i class="fab fa-instagram fa-2x"></i>
                </a>
                <a
                  className="asd"
                  style={{ marginLeft: 8, color: "rgb(118, 102, 223)" }}
                  href="/project-video"
                  // target="blank"
                  data-tip="Youtube"
                >
                  <i class="fab fa-youtube-square fa-2x"></i>
                </a>
              </div>
            </div>
          </div>
          <div
            class="col-lg-6 order-1 order-lg-2 hero-img"
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            <img src={Logo} class="img-fluid animated" alt="" />
          </div>
        </div>
      </div>
      {/* </div> */}
    </section>
  );
};
// }

FirstSection.propTypes = {
  fluid: PropTypes.bool,
  // applies .container-fluid className
};

export default withRouter(FirstSection);
